import React from "react"

export default function ListItemCheck({ title, property }) {
	return (
		<li className={!property ? "color-red" : ""}>
			{title} {property}
		</li>
	)
}
